class CartReservationTimer extends HTMLElement {
  connectedCallback() {
    this.clock = this.querySelector('[data-reservation-clock]');
    if (!this.clock) return;

    this.minutes = parseInt(this.dataset.minutes, 10) || 10;
    this.duration = this.minutes * 60 * 1000;
    this.storageKey = 'wanaka:cartReservationEnd';

    this.endTime = this.getEndTime();
    this.tick();
    this.interval = setInterval(this.tick.bind(this), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  getEndTime() {
    const stored = parseInt(sessionStorage.getItem(this.storageKey), 10);

    if (stored && stored > Date.now()) {
      return stored;
    }

    const endTime = Date.now() + this.duration;
    sessionStorage.setItem(this.storageKey, endTime);
    return endTime;
  }

  tick() {
    let remaining = this.endTime - Date.now();

    if (remaining <= 0) {
      this.endTime = Date.now() + this.duration;
      sessionStorage.setItem(this.storageKey, this.endTime);
      remaining = this.duration;
    }

    const totalSeconds = Math.floor(remaining / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    this.clock.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }
}

customElements.get('cart-reservation-timer') || customElements.define('cart-reservation-timer', CartReservationTimer);
